import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectMapsKeys } from '@core/react-query/features/projects/maps'
import {
  IProjectMapLayer,
  ProjectMapLayer,
} from '@core/entities/project/ProjectMapLayer'

const templateTransform = (response: IProjectMapLayer) =>
  ProjectMapLayer.new(response)

export const useGetProjectMapLayer = (
  payload: RequestTypes['getProjectMapLayer'],
  options?: UseQueryOptions<IProjectMapLayer, string, ProjectMapLayer>,
) => {
  return useQuery({
    select: templateTransform,
    ...projectMapsKeys.getProjectMapLayer(payload),
    ...options,
  })
}
